import GraphQlErrorBoundary from './components/GraphQlErrorBoundary';
export default GraphQlErrorBoundary;